import React from "react";
import styles from "./ProfileSidebar.module.css";

const ProfileSidebar = ({ activePage, setActivePage }) => {


  return (
    <aside className={styles.sidebar}>
      <h1 className={styles.sidebarTitle}>마이페이지</h1>
      <div className={styles.sidebarSection}>
        <h2 className={styles.sidebarSectionTitle}>회원정보</h2>
        <nav>
          <button
            onClick={() => setActivePage("editInfo")}
            className={
              ["editInfo", "confirmPassword"].includes(activePage)
                ? styles.active
                : ""
            }
          >
            회원정보 수정
          </button>
          <button
            onClick={() => setActivePage("withdrawal")}
            className={activePage === "withdrawal" ? styles.active : ""}
          >
            회원탈퇴
          </button>
        </nav>
      </div>
      <div className={styles.sidebarSection}>
        <h2 className={styles.sidebarSectionTitle}>고객센터</h2>
        <nav>
          <button
            onClick={() => setActivePage("consultationHistory")}
            className={activePage === "consultationHistory" ? styles.active : ""}
          >
            모의 견적 내역
          </button>
          <button
            // onClick={() => setActivePage("newConsultation")}
            // className={activePage === "newConsultation" ? styles.active : ""}
            className={styles.disabled}
            disabled
          >
            출간 내역
          </button>
        </nav>
      </div>
    </aside>
  );
};

export default ProfileSidebar;
